import { useActiveFolders } from "./useActiveFolders";

export const usePermissions = () => {
  const { current } = useActiveFolders();
  const { assets = [], folders = [] } = current?.permissions || {};

  return { assets, folders };
};
